import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import NvIcon from 'shared/components/nv-icon';

import { TimelineTimedQuiz } from 'redux/schemas/models/timed-quiz';
import { CheckIcon, todoIcon, todoProgress } from './todo-row';
import ProgressIcon from '../progress-icon';

type TimedQuizTodoProps = TimelineTimedQuiz & {
  thumbnailSrc: string,
  backgroundColor: string,
};

function TimedQuizTodo({
  type,
  title,
  progress,
  expirationDate,
  thumbnailSrc,
  backgroundColor,
}: TimedQuizTodoProps) {
  const deadlineMoment = moment(expirationDate);
  const deadlineDay = deadlineMoment.format('dddd');
  const deadlineTime = deadlineMoment.format('lll');
  const currentMoment = moment();

  const isMissed = progress === todoProgress.MISSED;
  const isComplete = progress === todoProgress.COMPLETED;
  const inProgress = progress === todoProgress.IN_PROGRESS;
  const isNotStarted = progress === todoProgress.NOT_STARTED;

  const showDueSoon = expirationDate
    && !isComplete
    && !isMissed
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    isComplete && 'completed',
    inProgress && 'in-progress',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  const icon = <NvIcon icon={todoIcon[type]} size='smallest' />;
  const showTodoIcon = isNotStarted || isMissed;
  const showIconProgress = inProgress;
  const showCheckIcon = isComplete;

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <div className='todo-cover'>
          {thumbnailSrc
            ? <img src={thumbnailSrc} alt='' />
            : <div className='square-thumbnail' style={{ backgroundColor }} />}
        </div>
        <div className='todo-icon'>
          {showTodoIcon && icon}
          {showCheckIcon && <CheckIcon />}
          {showIconProgress && <ProgressIcon>{icon}</ProgressIcon>}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isMissed && t.TIMELINE.EXERCISE_STATUS.MISSED()}
          {isComplete && t.TIMELINE.EXERCISE_STATUS.SUBMITTED()}
          {inProgress && t.TIMELINE.EXERCISE_STATUS.IN_PROGRESS()}
        </div>
        {expirationDate && (
          <div className='date'>
            <span className='day'>{deadlineDay}</span>
            <span className='time'>{deadlineTime}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default TimedQuizTodo;
